import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { CheckboxColumnComponent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'chassis-datatable-column-chooser',
    templateUrl: './column-chooser.component.html',
})
export class ColumnChooserComponent implements AfterViewInit {

    /**
     * Emits the list of column changes.
     */
    @Output() public change: EventEmitter<Array<CheckboxColumnComponent>> = new EventEmitter();

    @ViewChild('component') protected component;

    public ngAfterViewInit(): void {
        // Save the original callback.
        const onApply = this.component.onApply;

        // Create a new callback with additional actions, and
        // then execute the original callback.
        this.component.onApply = (changed) => {
            onApply.call(this.component, changed);

            if (changed.length) {
                this.change.next(changed);
            }
        };
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/column-chooser/column-chooser.component.ts